// cSpell: disable

const iConsole = `
.------------------------------------------------------------------------------.
|                                                                              |
|                           Welcome to Arch App . . .                          |
|                                                                              |
'------------------------------------------------------------------------------'
`;
export default iConsole;